<template>
  <div>
    <SpFinder
      ref="finder"
      reserve-selection
      row-key="item_id"
      :url="tableUrl"
      :setting="setting"
      fixed-row-action
      :hooks="{
        beforeSearch: beforeSearch,
      }"
    />
  </div>
</template>

<script>
import { useDialog } from '@shopex/finder'
import { getArticleInfo, deleteArticle, moveArticleSort, updateArticleShelfStatus } from '@/api/article'
import { tableSetting, commonDialogActions } from './config'

export default {
  data() {
    return {
      tableUrl: '/article/management'
    }
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  methods: {
    refresh() {
      this.$refs.finder && this.$refs.finder.refresh && this.$refs.finder.refresh(true)
      this.$refs.finder && this.$refs.finder.doLayout && this.$refs.finder.doLayout()
    },
    beforeSearch(params) {
      return {
        category_id: this.$route.query.category_id,
        ...params,
      }
    },
    handleAdd() {
      useDialog(null, {
        title: '新增文章',
        width: '620px',
        formData: {
          category_id: this.$route.query.category_id
        },
        component: () => import('./components/edit-dialog.vue'),
        actions: commonDialogActions
      }).then((result) => {
        if (!result || !result.refresh) return
        this.refresh()
      })
    },
    async handleEdit(row) {
      if (!row) return
      const response = await getArticleInfo(row.article_id)
      const formData = (response && response.data && response.data.data) || (response && response.data) || {}
      useDialog(null, {
        title: '编辑文章',
        width: '620px',
        formData,
        component: () => import('./components/edit-dialog.vue'),
        actions: commonDialogActions
      }).then((result) => {
        if (!result || !result.refresh) return
        this.refresh()
      })
    },
    handleDelete(row) {
      if (!row) return
      const articleId = row.article_id || row.id
      if (!articleId) return
      this.$confirm('确认删除该文章吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        await deleteArticle(articleId)
        this.$message.success('删除文章成功')
        this.refresh()
      }).catch(() => {})
    },
    async handleArticleSort(row, direction) {
      if (!row) return
      const articleId = row.article_id || row.id
      if (!articleId || !direction) return
      await moveArticleSort({
        article_id: articleId,
        direction
      })
      this.refresh()
    },
    handleMoveUp(row) {
      if (!row) return
      this.handleArticleSort(row, 'up')
    },
    handleMoveDown(row) {
      if (!row) return
      this.handleArticleSort(row, 'down')
    },
    handleMoveTop(row) {
      if (!row) return
      this.handleArticleSort(row, 'top')
    },
    handleMoveUnTop(row) {
      if (!row) return
      this.handleArticleSort(row, 'untop')
    },
    async handleStatusChange(row, value) {
      if (!row) return
      const articleId = row.article_id || row.id || row.item_id
      if (!articleId) {
        this.$message.warning('缺少文章 ID，无法更新上下架')
        return
      }
      const status = value === 1 || value === true || value === '1' ? 1 : 0
      try {
        await updateArticleShelfStatus({
          article_id: articleId,
          status
        })
        this.$message.success(status === 1 ? '已上架' : '已下架')
        this.refresh()
      } catch (e) {
        this.refresh()
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .search-field-value {
  width: auto !important;
}
::v-deep .sp-finder .cell .sp-finder-actions__wrap {
  justify-content: center !important;
}
</style>
